module.exports = __webpack_public_path__ + "static/media/test3_1.a34922d9.png";